import type { RegisteredServices } from '@/core/container/types'
import type { IconName } from '@/assets/icons/icons'

export const ReportingNumbersTableId = 'reportingNumbersTableId' as RegisteredServices

export const ReportingSubAccountsTableId = 'reportingSubAccountsTableId' as RegisteredServices
export const ReportingUsersTableId = 'reportingUsersTableId' as RegisteredServices

export const auditLogsReportingTable = 'auditLogsReportingTable' as RegisteredServices

export const ReportingSmsOverviewFiltersId = 'reportingSmsOverviewFilters' as const
export const ReportingEmailOverviewFiltersId = 'reportingEmailOverviewFilters' as const

export type ReportingEmptyStateType = 'messages' | 'calls' | 'auditLogs' | 'numbers'

export const REPORTING_EMPTY_STATE_ICONS = {
  messages: 'message',
  calls: 'call',
  auditLogs: 'history',
  numbers: 'call',
} as const satisfies Record<ReportingEmptyStateType, IconName>
